import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import './SelectApplicationType.scss';

import SmartImage from '../General/SmartImage';

import { hideUserLogin } from '../../Actions/UIActions';

const SelectApplicationType = props => {
  const sections = [
    {
      title: 'Shopper',
      subtitle: (
        <>
          A destination for shopping,
          <br />
          not scrolling.
        </>
      ),
      backgroundImage: 'https://static.shopmy.us/Circles/SignUp_Shopper.png',
      actions: [
        {
          label: 'Create an Account',
          onClick: props.selectShoppers
        }
      ]
    },
    {
      title: 'Creator',
      subtitle: (
        <>
          Where great taste leads to
          <br />
          great opportunities.
        </>
      ),
      backgroundImage: 'https://static.shopmy.us/Circles/SignUp_Creator.png',
      actions: [
        {
          label: 'Apply',
          href: '/apply/creator',
          onClick: props.closePanel
        }
      ]
    },
    {
      title: 'Brand',
      subtitle: (
        <>
          No one pushes your product like
          <br />
          the people who love them.
        </>
      ),
      backgroundImage: 'https://static.shopmy.us/Circles/SignUp_Brand.png',
      actions: [
        {
          label: 'Apply',
          onClick: props.selectBrands
        }
      ]
    }
  ];

  React.useEffect(() => {
    window.__ADD_EVENT__('Home - Open Select Application Type');
  }, []);

  return (
    <div className='select-application-type-container'>
      <div className='close-icn' onClick={props.closePanel}>
        <FontAwesomeIcon icon={faTimes} />
      </div>
      <div className='sections'>
        {sections.map((section, idx) => (
          <div className='section' key={section.title}>
            <div className='background-image-container'>
              <SmartImage noHoverScale fadeInDelay={idx * 100} src={section.backgroundImage} alt={section.title} />
            </div>
            <div className='content'>
              <div className='title-container'>
                <div className='title'>{section.title}</div>
                <div className='subtitle'>{section.subtitle}</div>
              </div>
              <div className='actions'>
                {section.actions.map((action, idx) => {
                  return action.href ? (
                    <Link className='action' to={action.href} onClick={action.onClick} key={idx}>
                      {action.label}
                    </Link>
                  ) : (
                    <div className='action' onClick={action.onClick} key={idx}>
                      {action.label}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className='footer'>
        <div>
          Already have an account?{' '}
          <span className='clickable' onClick={props.goToLogin}>
            Log in
          </span>
        </div>
        {window.__IS_NEW_CREATOR_ONBOARDING_LIVE__ && (
          <div>
            Have an invitation code?{' '}
            <span className='clickable' onClick={() => {
              props.history.push('/signup');
              props.closePanel();
            }}>
              Create Account
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

SelectApplicationType.propTypes = {
  selectBrands: PropTypes.func.isRequired,
  selectCreators: PropTypes.func.isRequired,
  selectShoppers: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
  goToLogin: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  ui: state.ui
});

export default connect(mapStateToProps, {
  hideUserLogin
})(withRouter(SelectApplicationType));
